import React, { useEffect, useState } from 'react'
import { Box } from '../../Components/Layout'
import { FeedCardList } from '../../Components/Feed'
import { FeedItem, getFeedBySlug } from '../../Api'
import { DRAFT_YEAR } from '../../Config/League/league.config'
import { Desc, Head2 } from '../../Components/Typography/Text.styles'

export const DraftNews: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [feed, setFeed] = useState<FeedItem[]>([])
  const [throughXFeed, setThroughXFeed] = useState<FeedItem[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const feedParams = {
    tag: `${DRAFT_YEAR} college draft`,
    includeVideos: true,
    limit: 10,
  }
  const throughXFeedParams = {
    tag: `through x`,
    includeVideos: true,
    limit: 10,
  }

  useEffect(() => {
    getDraftNews()
  }, [])

  const getDraftNews = async () => {
    try {
      const [feed, throughX] = await Promise.all([
        getFeedBySlug(feedParams),
        getFeedBySlug(throughXFeedParams),
      ])
      if (feed && feed.length > 0) {
        setFeed(feed)
      }
      if (throughX && throughX.length > 0) {
        setThroughXFeed(throughX)
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
      return
    }
  }

  return (
    <>
      {!loading && (
        <>
          <Box>
            {feed?.length > 0 && (
              <>
                <Head2>Draft Storylines</Head2>
                <FeedCardList
                  feedItems={feed}
                  section={'draft_news_feed'}
                  theme="light"
                />
              </>
            )}
          </Box>
          <Box>
            {throughXFeed?.length > 0 && (
              <>
                <Head2>Through X</Head2>
                <Desc>Learn from the perspective of top draft candidates</Desc>
                <FeedCardList
                  feedItems={throughXFeed}
                  section={'through_x_draft_feed'}
                  theme="light"
                />
              </>
            )}
          </Box>
        </>
      )}
    </>
  )
}
